var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageUploadClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9467 22.5014L11.3706 14.9253L3.79446 22.5014C3.3926 22.9033 2.84755 23.1291 2.27923 23.1291C1.71091 23.1291 1.16587 22.9033 0.764007 22.5014C0.362143 22.0996 0.136376 21.5545 0.136377 20.9862C0.136377 20.4179 0.362142 19.8728 0.764006 19.471L8.34015 11.8948L0.764004 4.3187C0.362141 3.91684 0.136377 3.37179 0.136376 2.80347C0.136376 2.23515 0.362141 1.69011 0.764004 1.28824C1.16587 0.886378 1.71091 0.660614 2.27923 0.660614C2.84755 0.660614 3.3926 0.886378 3.79446 1.28824L11.3706 8.86439L18.9467 1.28824C19.3486 0.886378 19.8937 0.660613 20.462 0.660613C21.0303 0.660613 21.5753 0.886378 21.9772 1.28824C22.3791 1.69011 22.6048 2.23515 22.6048 2.80347C22.6048 3.37179 22.3791 3.91684 21.9772 4.3187L14.4011 11.8948L21.9772 19.471C22.3791 19.8729 22.6048 20.4179 22.6048 20.9862C22.6048 21.5545 22.3791 22.0996 21.9772 22.5014C21.5753 22.9033 21.0303 23.1291 20.462 23.1291C19.8937 23.1291 19.3486 22.9033 18.9467 22.5014Z",
    fill: "#384466"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUploadClose);
export default __webpack_public_path__ + "static/media/imageUploadClose.43cd0ab6d1804d3051bfd603b02dc6dc.svg";
export { ForwardRef as ReactComponent };